module.exports = __webpack_public_path__ + "img/2fbd10de1252bd22ad1a4cfed008b5be.31cca1d3.jpg";